import { Stack } from "@mui/material";
import { IconButton } from "@src/appV2/redesign/components/IconButton";
import { useIsRebrand } from "@src/appV2/redesign/theme/RebrandProvider";
import { AccountSwitcherMobile } from "../AccountSwitcher/AccountSwitcher";

export interface NavigationMenuHeaderMobileProps {
  onClose: () => void;
}

export function NavigationMenuHeaderMobile(props: NavigationMenuHeaderMobileProps) {
  const { onClose } = props;
  const isRebrand = useIsRebrand();

  return (
    <Stack direction="row" gap={5} alignItems="center" flexGrow={0} flexShrink={0}>
      <AccountSwitcherMobile />
      <IconButton
        variant={isRebrand ? "link" : "outlineInverted"}
        iconType="close"
        size="large"
        onClick={onClose}
        sx={{ border: "none", height: "100%", aspectRatio: "1" }}
      />
    </Stack>
  );
}
